module.exports = __webpack_public_path__ + "static/shopmatic1-14c386c5a8dd65c2d7caad991e38d970.png";